import * as logicAnnuncio from "@logic/annuncio";
import Button from "@components/button";
import ImageInput from '@components/imageInput';
import InlineAlert from '@components/inlineAlert';
import React, { useState, useCallback, useMemo } from "react";
import SelectCategory from "@templates/selectCategory";
import SelectProvince from "@templates/selectProvince";
import TextInput from '@components/textInput';
import { ROUTES, useNavigator } from "@contexts/NavigatorContext";
import { SERVICE_TYPE } from "@logic/constants";
import { useCategories } from "@contexts/CategoriesContext";
import { selectUser } from "@store/userSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSnackbars } from "@contexts/SnackbarsContext";
import styles from "./AnnuncioCrea.module.css";

const fromFileInputToBlobPromise = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      resolve(event.target.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

const AnnuncioCrea = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { categories } = useCategories();
  const { navigate } = useNavigator();
  const { openSnackbar } = useSnackbars();

  const [loading, setLoading] = useState(false);
  const [formCategory, setFormCategory] = useState(null);
  const [formProvince, setFormProvince] = useState(null);
  const [formTitolo, setFormTitolo] = useState("");
  const [formCitta, setFormCitta] = useState("");
  const [formDescrizione, setFormDescrizione] = useState("");
  const [formImages, setFormImages] = useState([]);
  const [formErrors, setFormErrors] = useState(null);

  const publishOnlineCost = useMemo(() => {
    if (!formCategory || !user?.accountType) {
      return 0;
    }

    const selectedCategory = categories.find((x) => String(x.id) === String(formCategory));
    if (!selectedCategory?.categoryPrices?.length) {
      return 0;
    }

    const publishOnlinePrice = selectedCategory.categoryPrices.find((categoryPrice) => (
      categoryPrice.accountType === user.accountType
      && categoryPrice.serviceType === SERVICE_TYPE.PUBLISH_ONLINE.value
    ));

    return publishOnlinePrice?.price ?? 0;
  }, [categories, formCategory, user?.accountType]);

  const isSelectedCategoryPaid = publishOnlineCost > 0;

  const formatCents = (cents) => (cents / 100).toFixed(2).replace(".", ",");

  const onCreaClick = useCallback(async () => {
    setLoading(true);
    setFormErrors(null);

    const filePromises = formImages.map(fromFileInputToBlobPromise);
    const filesBlobs = await Promise.all(filePromises);

    dispatch(logicAnnuncio.createAdvertisement({
      title: formTitolo,
      description: formDescrizione,
      categoryId: formCategory,
      province: formProvince,
      city: formCitta,
      imagesBlobs: filesBlobs,
    }))
      .then(() => {
        openSnackbar("✨ Annuncio creato!");
        navigate(ROUTES.I_MIEI_ANNUNCI);
      })
      .catch((e) => {
        openSnackbar("❌ " + e.message);
        setFormErrors(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [formImages, dispatch, formTitolo, formDescrizione, formCategory, formProvince, formCitta, openSnackbar, navigate]);

  return (
    <>
      <br></br>
      <div className='row'>
        <div className='col'>
          <span className='page-title'>Crea annuncio</span>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <SelectCategory
            value={formCategory}
            setValue={setFormCategory}
            disabled={loading}
          />
          {isSelectedCategoryPaid && (
            <span className={styles.categoryPaidWarning}>
              Questa categoria prevede un costo di pubblicazione ({formatCents(publishOnlineCost)} crediti).
            </span>
          )}
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <TextInput
            label="Titolo"
            value={formTitolo}
            setValue={setFormTitolo}
            disabled={loading}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <SelectProvince
            label="Provincia"
            value={formProvince}
            setValue={setFormProvince}
            disabled={loading}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <TextInput
            label="Località"
            value={formCitta}
            setValue={setFormCitta}
            disabled={loading}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <TextInput
            label="Descrizione"
            value={formDescrizione}
            setValue={setFormDescrizione}
            disabled={loading}
            multiline
            rows={6}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <ImageInput
            label="Foto"
            buttonText="Aggiungi foto"
            setValue={setFormImages}
            disabled={loading}
          />
        </div>
      </div>
      <br />
      <br />
      <div className='row'>
        <div className='col col-flex-center'>
          <Button
            color="primary"
            // icon="save"
            onClick={onCreaClick}
            text="Salva"
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <InlineAlert type="error" text={formErrors} />
        </div>
      </div>
    </>
  );
};

export default AnnuncioCrea;
